import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {GreatForm} from 'components/common';
import {InputField} from 'components/common/rc-fields';
import {createActiveImageSetVersion, updateActiveImageSetVersion} from 'api/images';

const ActiveImageSetVersionForm = ({form, initialValues, onCancel, onSubmitSuccess}) => {
  const isUpdate = !isEmpty(initialValues);
  const {versionCode} = initialValues || {};

  return (
    <GreatForm
      form={form}
      onCancel={onCancel}
      submitFn={
        isUpdate
          ? (payload) => updateActiveImageSetVersion({id: initialValues.id, ...payload})
          : (payload) => createActiveImageSetVersion(payload)
      }
      onSuccess={onSubmitSuccess}
      successMsg={`Image has been ${isUpdate ? 'updated' : 'created'} successfully`}
    >
      <Grid container spacing={2}>
        {!isUpdate && (
          <Grid item xs={12}>
            <InputField name="type" label="Type" rules={[{required: true, message: 'Please enter Type'}]} form={form} />
          </Grid>
        )}
        <Grid item xs={12}>
          <InputField
            name="versionCode"
            label="Version Code"
            initialValue={versionCode || ''}
            rules={[{required: true, message: 'Please enter Version Code'}]}
            form={form}
          />
        </Grid>
      </Grid>
    </GreatForm>
  );
};

ActiveImageSetVersionForm.propTypes = {
  form: formShape.isRequired,
  initialValues: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmitSuccess: PropTypes.func.isRequired,
};

ActiveImageSetVersionForm.defaultProps = {
  initialValues: {},
};

export default createForm()(ActiveImageSetVersionForm);
